import React, { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../app/SearchBar/SearchBar";
import './Home.scss';
import {Helmet} from "react-helmet";
import { tokenState } from "../../../atoms/token";
import Tab from '@mui/material/Tab';
import { useRecoilState } from "recoil";
import { announcementState } from "../../../atoms/announcement";
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";
import SearchFilter from "../../app/SearchFilter/SearchFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import { Cart } from "../../../models/assetResponse";
import { cartState } from "../../../atoms/cart";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";

interface LinkTabProps {
    label?: string;
    href?: string;
}

const Home = () => {
  const initialForm = {};
  const [value, setValue] = React.useState(0);
  const [filterText, setFilterText] = useState('');
  const [announcement, setAnnouncement] = useRecoilState(announcementState);
  const [showDialog, setShowDialog] = useState(false);
  const [token] = useRecoilState(tokenState);
  const [cartItems, SetCartState] = useRecoilState(cartState);

  const navigate = useNavigate();
  const [form, setForm] = useReducer(
    (form, updates) => ({...form, ...updates}),
    initialForm
  );
  const [localForm, setLocalForm] = useState({});

  const handleViewDownloadsClick = () => {
    setShowDialog(true);
  }

  const getCart = () => { 
    const url = `${environment.eticApiUrl}GetCart`;
    const apiService = new APIService<Cart>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any[]) => {
      SetCartState(res);
    });
  }

  const handleRemoveClick = (rowParams) => {
    const filteredCart = cartItems.filter((row) => row.parentDocId !== rowParams.row.ticParentDocId);
    let cart = getParentDocIds(filteredCart);
    const url = `${environment.eticApiUrl}UpdateCart`;
    const apiService = new APIService<any[]>(axios, new CacheService, url, token);

    apiService.add(cart, url).then((res:any[]) => {
      console.log('set cart', res);
      getCart();
    });
  }
  
  const handleSearchClick = () => {
    console.log('husky navigating with form', form);
    navigate('searchResults', { state: { filterText, filterOptions: localForm } });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    event.preventDefault();
    setValue(newValue);
  };
  
  const getParentDocIds = (items) => {
    let parentDocIds = [];
    items.forEach(item => {
      parentDocIds.push(item.parentDocId);
    });

    return parentDocIds;
  }
  
  const handleSaveClick = (items) => {
    let cart = getParentDocIds(items);

    const url = `${environment.eticApiUrl}UpdateCart`;
    const apiService = new APIService<any[]>(axios, new CacheService, url);

    apiService.add(cart, url).then((res:any[]) => {
      getCart();
    });

    setShowDialog(false);
  }

  const handleDownloadItemsClick = (items) => {
    const url = `${environment.eticApiUrl}CreateOrderFromCart`;
    const apiService = new APIService<Cart>(axios, new CacheService, url);

    apiService.getAnyAsync().then((res:any) => {
      console.log('cart  created', res);
      getCart();

      const orderUrl = `${environment.eticApiUrl}CreateOrderZip/${res.id}`;
      const orderApiService = new APIService<Cart>(axios, new CacheService, orderUrl);
  
      orderApiService.getAnyAsync().then((res:any) => {
        console.log('zip  creating', res);
        navigate('/orderHistory');

      });
    });
  
    setShowDialog(false);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
  }

  const handleFilterChange = (updatedFields: any) => {
    console.log('Form update received:', updatedFields);
    setForm((prevForm) => ({ ...prevForm, ...updatedFields }));
    setLocalForm((prevForm) => ({ ...prevForm, ...updatedFields }));
  };

  const handleKeyUp = (event) => {
    const newText = event.value;
    setFilterText(newText);
    navigate('searchResults', { state: { filterText: newText, filterOptions: localForm } });
  };

  const LinkTab = (props: LinkTabProps) => {
    return (
      <Tab
          component="a"
          onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
              event.preventDefault();
          }}
          {...props}
      />
    );
  }

  return (
    <div className="home-container">
      <Helmet>
          <meta charSet="utf-8"/>
          <title>Welcome and Search Page</title>
      </Helmet>
      
      <div className="home-content">
        <h2 className="home-title">Welcome to the Technical Information Center (TIC)</h2>
        { announcement && <h4 className="announcement center">Announcement: {announcement}</h4>}
      </div>

      <div className="description">
        <span>
          The National Park Service (<abbr>NPS</abbr>) designated the Technical Information Center as the central repository for all <abbr>NPS</abbr> generated planning, design, construction drawings and related technical report documents. &nbsp;
          <abbr>e</abbr>TIC (electronic Technical Information Center) is the electronic document management system used to manage these documents and drawings.
        </span>
      </div>

      <div className="search-area ">
        {!environment.publicMode && showDialog &&
          <ViewDownloadsDialog
            title={"Selected Items For Download"}
            //downloads={itemsForDownload}
            closeButtonText={'Cancel'}
            handleActionButtonText={'Download'}
            //handleRemoveItem={handleRemoveClick}
            //handleSaveClick={handleSaveClick}
            handleDownloadItemsClick={handleDownloadItemsClick}
            handleCloseClick={handleCloseClick}
          />
        }
        {!environment.publicMode && (
        <span className="center">
        <Button 
          id="upload"
          variant="outlined" 
          className=""         
          startIcon={<FontAwesomeIcon icon={["fas", "folder-arrow-down"]} />}
          onClick={handleViewDownloadsClick}>
            Items Selected For Download ({cartItems.length})
        </Button>
        </span>
        )}
                
        <SearchFilter handleFilterChange={handleFilterChange} filterText={filterText} expanded={false} />
        <SearchBar placeholder="Search the Technical Information Center..." handleKeyUp={handleKeyUp} filterText={filterText} onFilterTextChange={setFilterText} onSearchClick={handleSearchClick} />
      </div>
    </div>
  );
}

export default Home;

